function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) return '-';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function buildTicketsTableModel(dtos) {
  return dtos.map((dto) => ({
    ...dto,
    createdAt: formatDate(dto.created),
    updatedAt: formatDate(dto.updated),
  }));
}
